import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@shoflo/polymer/components/Button/Button';
import styled from 'styled-components';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';

const StyledBannerGroup = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex: 1;
  justify-content: center;
`;
const StyledBanner = styled.div`
  margin-top: 0;
  margin-right: 16px;
  background: #fffde0;
  border: 1px solid #666012;
  padding: 6px 12px;
  border-radius: 5px;
  font-size: 14px;
  font-weight: 600;
  color: #666012;

  svg {
    margin-right: 3px;
    font-size: 16px;
  }
`;
const StyledButton = styled(Button)`
  margin-top: 0;
`;

const ReadOnlyBanner = ({ event, onDuplicateClick }) => {
  const onDuplicateClickHandler = onDuplicateClick.bind(this, event);

  const archivedEvent =
    event.archived ||
    event.endOn <= moment().hour(0).minute(0).subtract(7, 'days').valueOf();

  if (!archivedEvent) return null;

  const bannerText = 'This is an archived event and is in read only mode!';

  return (
    <StyledBannerGroup>
      <StyledBanner>
        <FontAwesomeIcon icon={faInfoCircle} /> {bannerText}
      </StyledBanner>
      <StyledButton color="primary" variant="outlined" onClick={onDuplicateClickHandler}>
        Duplicate event
      </StyledButton>
    </StyledBannerGroup>
  );
};

ReadOnlyBanner.propTypes = {
  event: PropTypes.object.isRequired,
  onDuplicateClick: PropTypes.func.isRequired,
};

export default ReadOnlyBanner;
